import React from 'react';
import { useTranslation } from 'react-i18next';
import { TDR } from 'tdr-common';
import { resolveLocalizedText } from '../../../helpers/resolveLocalizedText';

export type CustomMessageSectionProps = {
	section: TDR.SearchConfig.CustomMessageSection;
};

export function CustomMessageSection({ section }: CustomMessageSectionProps) {
	const { i18n } = useTranslation();
	const header = section.header ? resolveLocalizedText(section.header, i18n.language) : null;
	const body = section.body ? resolveLocalizedText(section.body, i18n.language) : null;

	if (!header && !body) {
		return null;
	}

	return (
		<section className='px-5 pt-6 pb-2 sm:px-0 sm:pt-4' data-cy='custom-message-section'>
			{header ? (
				<h2 className='font-poppins text-tablz-text-gray-2 text-lg font-medium mb-3'>{header}</h2>
			) : null}
			{body ? (
				<p className='font-poppins text-sm leading-[1.4] text-white/70 whitespace-pre-line'>{body}</p>
			) : null}
		</section>
	);
}
